import { sandhillsRequest } from '@Components/Utilities/SandhillsUtility';

const transportMethods = ['webSockets', 'longPolling'];
// Isolated SignalR setup in the event we end up having to support multiple hubs
let _bidCallerBiddingSignalRConnection = null;
let _bidCallerBiddingSignalRHub = null;

const setupBidCallerPreBiddingSignalRHub = (hubUrl, isEmployee, listingIds, updateAuctionBiddingData, calculateEstimatedTimes) => {

    // Try catch around the connection creation in the event the SignalR library is not available
    // This will at least prevent the page from going completely blank
    try {
        _bidCallerBiddingSignalRConnection = $.hubConnection();
    }
    catch (ex) { }
    if (_bidCallerBiddingSignalRConnection == null || _bidCallerBiddingSignalRConnection == undefined) {
        console.log("SignalR connection failed: None available");
        return false;
    }

    _bidCallerBiddingSignalRConnection.url = hubUrl;
    _bidCallerBiddingSignalRHub = _bidCallerBiddingSignalRConnection.createHubProxy("bidcallerprebidding");
    if (_bidCallerBiddingSignalRHub == null || _bidCallerBiddingSignalRHub == undefined) {
        console.log("SignalR connection failed: No hub was provided");
        return false;
    }

    _bidCallerBiddingSignalRConnection.logging = isEmployee;

    _bidCallerBiddingSignalRHub.on("OnPreBidPlaced", function(listingId) {
        updateAuctionBiddingData(listingId, false);
    });

    _bidCallerBiddingSignalRHub.on("ProcessAverageTimesPerLot", function (eventAverageLotTimeInformation) {
        calculateEstimatedTimes(eventAverageLotTimeInformation);
    });

    _bidCallerBiddingSignalRConnection.disconnected(function () {
        if (_bidCallerBiddingSignalRConnection.logging === true) { console.log("Failed to reconnect"); }
        setTimeout(function () {
            startSignalRConnection(listingIds);
        }, 3000); // attempt to restart connection after 3 seconds.
    });

    _bidCallerBiddingSignalRConnection.reconnecting(function () {
        if (_bidCallerBiddingSignalRConnection.logging === true) { console.log("Attemptting to reconnect"); }
    });

    _bidCallerBiddingSignalRConnection.reconnected(function () {
        if (_bidCallerBiddingSignalRConnection.logging === true) { console.log("Attempt to reconnect has succeeded"); }
    });

    startSignalRConnection(listingIds);

    return true;
};

const startSignalRConnection = (listingIds) => {
    _bidCallerBiddingSignalRConnection.start({ jsonp: true, transport: transportMethods }).done(function () {
        _bidCallerBiddingSignalRHub.invoke("addToGroups", listingIds);
        if (_bidCallerBiddingSignalRConnection.logging == true) { console.log("Connection succeeded"); }
    }).fail(function (e) {
        console.log("SignalR connection failed: " + e);
    });
}

const placeBidCallerBid = (routes, auctionBiddingData) => {
    return sandhillsRequest({
        url: routes.PlacePreBid,
        data: { auctionBiddingData: auctionBiddingData },
        method: 'post',
        errorHandling: {
            useConsole: false,
            useAlert: false
        }
    });
}

export {
    setupBidCallerPreBiddingSignalRHub,
    placeBidCallerBid
};